export const ruleEditors = ['Marvin Yaldo', 'Zeyad Jabra'];
export const ruleEditorPermission = 'Commission Rule Editor';
export const currentUser = 'Marvin Yaldo';

export const manualLinePayees = [
  'Alex Rivera',
  'Jordan Lee',
  'Casey Nguyen',
  'Sam Patel',
  'Morgan Brooks',
  'Angelo Jarbo',
  'Riley Chen',
  'Quinn Harper',
  'Taylor Ortiz',
  'Drew Kim',
];

export const lockedPeriods = ['September 2026', 'August 2026'];
